import { Button, FormControl, Grid, InputLabel, MenuItem, Select, Modal } from '@mui/material';
import { Search, FilterList } from '@mui/icons-material'
import React, { FC, useEffect, useState } from 'react';
import { useTrademarkVehicleStore } from '../../hooks/useTrademarkVehicleStore';
import { useTypeVehicleStore } from '../../hooks/useTypeVehicleStore';
import { useContrataStore } from '../../hooks/useContrataStore';
import { useVehicleStore } from '../../hooks/useVehicleStore';
import { useModelVehicleStore } from '../../hooks/useModelVehicleStore';
import { makeStyles } from '@mui/styles';
import { useAuthStore } from '../../hooks';
import { Role } from '../../types/roles/roleTypes';

//estilos para el modal
const useStyles = makeStyles((theme) => ({
    modalContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        zIndex: 1300, // Asegúrate de que sea mayor que el zIndex del contenido de la aplicación
    },
    modal: {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        display: 'flex',
        flexDirection: 'column',
        width: '70%',
        height: '100%',
        transition: 'transform 1.5s ease-in-out',
        transform: 'translateX(100%)',
    },
    modalContent: {
        flexGrow: 1,
        backgroundColor: 'white',
        overflow: 'auto',
        padding: 16,
    },
    modalOpen: {
        transform: 'translateX(0%)', // Cambio en la transformación al abrir el modal
    },
    modalClosed: {
        transform: 'translateX(100%)', // Transición inversa al cerrar
    },
}));

type filterType = {
    trademark: number,
    model: number,
    type: number,
    contrata: number
}

interface VehiclesFilterProps {
    loading: (isLoading: boolean) => void;
}

const VehiclesFilter: FC<VehiclesFilterProps> = ({ loading }) => {
    const classes = useStyles();
    const [isResponsive, setIsResponsive] = useState<boolean>(window.innerWidth <= 760);
    const [filterButton, setFilterButton] = useState<boolean>(false)

    const { user } = useAuthStore()
    const { getVehicles, filterVehicles } = useVehicleStore()
    const { getTrademarkVehicles, trademarkVehicles } = useTrademarkVehicleStore();
    const { getTypeVehicles, typeVehicles } = useTypeVehicleStore();
    const { getContratas, contratas } = useContrataStore();
    const { getModelVehicles, modelVehicles } = useModelVehicleStore()
    const [filters, setFilters] = useState<filterType>({
        trademark: 0,
        model: 0,
        type: 0,
        contrata: 0,
    })

    const userRole:Role|any = user.userType;

    useEffect(() => {
        const handleResize = (): void => {
            setIsResponsive(window.innerWidth <= 760);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    useEffect(() => {
        infoApi();
    }, [])

    const infoApi = async () => {
        await getTrademarkVehicles()
        await getTypeVehicles()
        await getContratas()
        await getModelVehicles()
    }

    const onFilters = (e) => {
        const { value, name } = e.target
        setFilters({
            ...filters,
            [name]: value,
        })
    }

    const handleSubmit = async () => {
        loading(true);
        setFilterButton(false)
        await filterVehicles(filters.trademark, filters.model, filters.type, filters.contrata)
        loading(false);
    }

    const handleCancel = async () => {
        loading(true);
        setFilters({
            trademark: 0,
            model: 0,
            type: 0,
            contrata: 0
        })
        setFilterButton(false)
        await getVehicles({ status: 1 });
        loading(false);
    }

    const filterModal = () => {
        setFilterButton(!filterButton)
    }

    return (
        <>
            {!isResponsive ? (<Grid item container xs={12} direction="row" justifyContent="space-between" alignItems="center" sx={{ border: 'solid 1px #e9e2e2', borderRadius: '10px' }}>
                <Grid xs={12} sm={12} md={9} lg={9} xl={9} sx={{ padding: '10px' }} marginBottom="-10px" justifyContent="center">
                    <FormControl sx={{ margin: "5px" }} >
                        <InputLabel id="demo-simple-select-label" style={{ fontSize: "13px" }}>
                            MARCA
                        </InputLabel>
                        <Select
                            id="combo-box-trademark"
                            name='trademark'
                            size="small"
                            label="MARCA"
                            value={filters.trademark}
                            onChange={onFilters}
                            sx={{ width: '150px', fontSize: "12px" }}>
                            {trademarkVehicles?.map((mark) => (<MenuItem key={mark.id} sx={{ width: "200px" }} value={mark.id}>{mark.name}</MenuItem>))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{ margin: "5px" }} >
                        <InputLabel id="demo-simple-select-label" style={{ fontSize: "13px" }}>
                            MODELO
                        </InputLabel>
                        <Select
                            id="combo-box-model"
                            name='model'
                            size="small"
                            label="MODELO"
                            value={filters.model}
                            onChange={onFilters}
                            sx={{ width: '150px', fontSize: "12px" }}>
                            {modelVehicles?.map((model) => (<MenuItem key={model.id} sx={{ width: "200px" }} value={model.id}>{model.name}</MenuItem>))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{ margin: "5px" }}>
                        <InputLabel id="demo-simple-select-label" style={{ fontSize: "13px" }} >
                            TIPO
                        </InputLabel>
                        <Select
                            id="combo-box-type"
                            name='type'
                            size="small"
                            label="TIPO"
                            value={filters.type}
                            onChange={onFilters}
                            sx={{ width: '150px', fontSize: "12px" }}>
                            {typeVehicles?.map((type) => (<MenuItem key={type.id} sx={{ width: "260px" }} value={type.id}>{type.name}</MenuItem>))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{ margin: "5px" }}>
                        <InputLabel id="demo-simple-select-label" style={{ fontSize: "13px" }}>
                            CONTRATA
                        </InputLabel>
                        <Select
                            id="combo-box-contrata"
                            name='contrata'
                            size="small"
                            label="CONTRATA"
                            value={filters.contrata}
                            onChange={onFilters}
                            sx={{ width: '150px', fontSize: "12px" }}>
                            {contratas?.map((contrata) => (<MenuItem key={contrata.id} sx={{ width: "180px" }} value={contrata.id}>{contrata.name}</MenuItem>))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item display='flex' justifyContent='center' padding='5px' xs={12} sm={12} md={3} lg={3} xl={3}>
                    <Button
                        startIcon={<Search />}
                        size="small"
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{ width: '140px', height: '40px', backgroundColor: '#212D39', color: '#fff', textTransform: 'none', padding: '4px 7px', "&:hover": { backgroundColor: "#212D39" }, fontSize: "12px", marginRight: '3px', lineHeight: '12px' }}>
                        Filtrar búsqueda
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        onClick={handleCancel}
                        sx={{ width: '140px', height: '40px', backgroundColor: '#5a5959', color: '#fff', textTransform: 'none', padding: '4px 7px', "&:hover": { backgroundColor: "#a79f9f" }, fontSize: "12px" }}>
                        Cancelar filtros
                    </Button>
                </Grid>
            </Grid >) : (
                <>
                    {/* Botón de filtro - responsive */}
                    <Button startIcon={<FilterList />}
                        size="small" variant="contained" sx={{ height: "40px", marginBottom: "-125px", backgroundColor: '#212D39', color: '#fff', textTransform: 'none', padding: '4px 7px', "&:hover": { backgroundColor: "#212D39" }, fontSize: "12px", lineHeight: '12px', marginRight: "auto", alignItems: "center" }} onClick={filterModal}>Filtros</Button>
                </>
            )}
            {filterButton &&
                <div>
                    <Modal
                        open={filterButton}
                        onClose={filterModal}
                        className={classes.modalContainer}
                    >
                        <div className={`${classes.modal} ${filterButton ? classes.modalOpen : classes.modalClosed}`}>
                            <div className={classes.modalContent}>
                                <h2>FILTROS</h2>
                                <Grid sx={{ padding: '5px' }} justifyContent="center">
                                    <FormControl sx={{ margin: "5px", marginBottom: "15px" }} >
                                        <InputLabel id="demo-simple-select-label" style={{ fontSize: "13px" }}>
                                            MARCA
                                        </InputLabel>
                                        <Select
                                            id="combo-box-trademark"
                                            name='trademark'
                                            size="small"
                                            label="MARCA"
                                            value={filters.trademark}
                                            onChange={onFilters}
                                            sx={{ width: '200px', fontSize: "12px" }}>
                                            {trademarkVehicles?.map((mark) => (<MenuItem key={mark.id} sx={{ width: "200px" }} value={mark.id}>{mark.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                    <FormControl sx={{ margin: "5px", marginBottom: "15px" }} >
                                        <InputLabel id="demo-simple-select-label" style={{ fontSize: "13px" }}>
                                            MODELO
                                        </InputLabel>
                                        <Select
                                            id="combo-box-model"
                                            name='model'
                                            size="small"
                                            label="MODELO"
                                            value={filters.model}
                                            onChange={onFilters}
                                            sx={{ width: '200px', fontSize: "12px" }}>
                                            {modelVehicles?.map((model) => (<MenuItem key={model.id} sx={{ width: "200px" }} value={model.id}>{model.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                    <FormControl sx={{ margin: "5px", marginBottom: "15px" }}>
                                        <InputLabel id="demo-simple-select-label" style={{ fontSize: "13px" }} >
                                            TIPO
                                        </InputLabel>
                                        <Select
                                            id="combo-box-type"
                                            name='type'
                                            size="small"
                                            label="TIPO"
                                            value={filters.type}
                                            onChange={onFilters}
                                            sx={{ width: '200px', fontSize: "12px" }}>
                                            {typeVehicles?.map((type) => (<MenuItem key={type.id} sx={{ width: "260px" }} value={type.id}>{type.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                    <FormControl sx={{ margin: "5px", marginBottom: "15px" }}>
                                        <InputLabel id="demo-simple-select-label" style={{ fontSize: "13px" }}>
                                            CONTRATA
                                        </InputLabel>
                                        <Select
                                            id="combo-box-contrata"
                                            name='contrata'
                                            size="small"
                                            label="CONTRATA"
                                            value={filters.contrata}
                                            onChange={onFilters}
                                            sx={{ width: '200px', fontSize: "12px" }}>
                                            {contratas?.map((contrata) => (<MenuItem key={contrata.id} sx={{ width: "180px" }} value={contrata.id}>{contrata.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item display='flex' justifyContent='center' padding='5px' xs={12} sm={12} md={3} lg={3} xl={3}>
                                    <Button
                                        startIcon={<Search />}
                                        size="small"
                                        variant="contained"
                                        onClick={handleSubmit}
                                        sx={{ width: '120px', height: '40px', backgroundColor: '#212D39', color: '#fff', textTransform: 'none', padding: '4px 7px', "&:hover": { backgroundColor: "#212D39" }, fontSize: "12px", marginRight: '3px', lineHeight: '12px' }}>
                                        Filtrar búsqueda
                                    </Button>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        onClick={handleCancel}
                                        sx={{ width: '120px', height: '40px', backgroundColor: '#5a5959', color: '#fff', textTransform: 'none', padding: '4px 7px', "&:hover": { backgroundColor: "#a79f9f" }, fontSize: "12px" }}>
                                        Cancelar filtros
                                    </Button>
                                </Grid>
                            </div>
                        </div>
                    </Modal>
                </div>}
        </>
    )
};

export default VehiclesFilter;